module.exports = __webpack_public_path__ + "img/10.070ec82c.jpg";